/**
 * Экспорт/загрузка данных
 */
import {CsvHelper} from "../helpers/CsvHelper";

const download = (data, filename, type) => {
    let textFileAsBlob = new Blob([data], {type: type});
    let downloadLink = document.createElement("a");
    downloadLink.download = filename;
    downloadLink.innerHTML = "Download File";
    if (window.webkitURL != null){
        downloadLink.href = window.webkitURL.createObjectURL(textFileAsBlob);
    } else {
        downloadLink.href = window.URL.createObjectURL(textFileAsBlob);
        downloadLink.onclick = function(event){
            document.body.removeChild(event.target);
        };
        downloadLink.style.display = "none";
        document.body.appendChild(downloadLink);
    }
    downloadLink.click();
}

export default {
    methods: {
        /**
         * Загрузка данных в файл в utf-8
         * @param {string} data
         * @param {string} filename
         * @param {string} type
         */
        downloadDataUtf8(data, filename, type = 'text/csv') {
            download("\uFEFF" + data, filename, type);
        },
        /**
         * Загрузка данных в файл в windows-1251
         * @param {string} data
         * @param {string} filename
         * @param {string} type
         */
        downloadDataWin1251(data, filename, type = 'text/csv') {
            download(data, filename, type);
        },
        /**
         * Выгрузка массива данных в CSV
         * @param fileName
         * @param arrayData массив данных
         * @param th необязательный параметр заголовков
         * @param stringsEncoded кодировать все строки?
         */
        downloadCsvReport(fileName, arrayData, th = null, stringsEncoded = false) {
            const rowSeparator = "\r\n";
            const columnSeparator = ';';

            let csvData = th ? th + rowSeparator : '';
            arrayData.map(row => csvData += (
                stringsEncoded
                    ? row.map(item => CsvHelper.encodeString(item))
                    : row
            ).join(columnSeparator) + rowSeparator);

            this.downloadDataUtf8(csvData, fileName);
        }
    },
}
